export default "__VITE_ASSET__DOvTSlir__"